import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NiceLegalTextComponent } from './nice-legal-text.component';
import { NiceLegalTextModalService } from './nice-legal-text.service';
import { TextPersonalInfoModule } from './text-personal-info/index';
import { TextSocialSecurityInfoModule } from './text-social-security-info/index';
import { TextThirdPartyInfoModule } from './text-third-party-info/index';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [NiceLegalTextComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TextPersonalInfoModule, TextSocialSecurityInfoModule, TextThirdPartyInfoModule,
  ],
  providers: [NiceLegalTextModalService],
  entryComponents: [NiceLegalTextComponent],
})
export class NiceLegalTextModule { }
